var map = {
	"./black/paiduitongzhi2.png": "ilRG",
	"./blue/paiduitongzhi2.png": "LXI3",
	"./white/paiduitongzhi2.png": "zcWe"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pHEQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/paiduitongzhi2\.png$
// module id = pHEQ
// module chunks = 24